// extracted by mini-css-extract-plugin
module.exports = {"survey":"PublicSurveys_survey__a6xyl","disabledSurvey":"PublicSurveys_disabledSurvey__hY4Kg"};